export default "__VITE_ASSET__DAhbNB7f__"